import { render } from "./AlloyDetails.vue?vue&type=template&id=68a38a01"
import script from "./AlloyDetails.vue?vue&type=script&lang=js"
export * from "./AlloyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__